import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin`;

export const adminApi = axios.create({ baseURL: BASE });

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("sr_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 403 && err.response?.data?.detail?.code === "authorization_required") {
      window.dispatchEvent(new CustomEvent("sr-authorization-required", { detail: err.response.data.detail }));
    }
    if (err.response?.status === 401) {
      localStorage.removeItem("sr_admin_token");
      if (!window.location.pathname.endsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof detail === "object") return detail.message || "Something went wrong. Please try again.";
  return String(detail);
};
